/**
 * 푸시 설정 (/adm/push/config) — 앱별(장비불러·악덕알리미) 푸시 문구·전달방식 관리
 * ($j.Pages.Admin.PushConfig / body data-page-name="PushConfig")
 *
 * 목록(DataTables) + 편집·신규·프로토콜 도움말 모달(JBModal, JS 로 빌드).
 * 버튼·링크는 data-pc="함수명" 위임으로 부른다 — window 에 함수를 내놓지 않는다.
 * 데이터에서 나오는 색(대상 배지·알림 색 견본)만 CSS 변수 하나로 넘기고 모양은 sass 가 그린다.
 */
export default class PushConfig {
    initialize() { initialize(); }
}

let $table = null;
let editor=null;
let selectedCode=null;
let selectedApp='JB'; // 앱 탭 (JB:장비불러, BD:악덕알리미)
function initialize(){
    initPage();
    initHandler();
}

function initPage(){
    const columns = [
        {data: 'rel_table', title: 'table',
            render: function (data, type, row) {
                return tableBadge(row.rel_table);
            }
        },
        {data: 'rel_action', title: 'action',
            render: function (data, type, row) {
                return `<span class="pc-sm85">${esc(row.rel_action || '')}</span>`;
            }
        },
        {data: 'event', title: '설명',
            render: function (data, type, row) {
                // 푸시본문 칸과 같은 모달을 연다. 설명만 고치려고 본문 칸을 찾아 누르지
                // 않게 하려는 것 — 목록에서 눈에 먼저 들어오는 쪽이 설명이다.
                // 비어 있으면 누를 자리가 없어지므로 자리표시를 둔다.
                const txt = (row.event || '').trim();
                const inner = txt
                    ? esc(txt)
                    : `<span class="pc-noevent">(설명 없음)</span>`;
                return `<a href='#' data-pc='edit_pop' data-n='${row.num}'>${inner}</a>`;
            }
        },
        {data: 'target', title: '대상',
            render: function (data, type, row) {
                return targetBadge(row.target);
            }
        },
        // 알림 — 알림페이지(DB) 기록 여부. 종 아이콘만. (send_mode 1·2=기록, 3=미기록)
        {data: 'send_mode', name: 'alim', title: '알림', className: 'text-center',
            render: function (data, type, row) {
                const alimOn = [1, 2].includes(Number(row.send_mode) || 1);
                return `<i class="fas fa-bell pc-bell${alimOn ? ' is-on' : ''}" title="알림페이지(DB) ${alimOn ? '기록' : '미기록'}"></i>`;
            }
        },
        // FCM — FCM 발송(send_mode 1·3)일 때만 표시, 알림만(2)이면 빈칸.
        //   JB=앱효과 아이콘(TTS/팝업/효과음) 표시 / BD=앱효과 미사용이라 FCM 배지만.
        {data: null, name: 'fcm', title: 'FCM', className: 'text-center col-fcm',
            render: function (data, type, row) {
                if (Number(row.send_mode) === 2) return ''; // 알림만 → FCM 미발송 → 빈칸
                const app = row.app_code || selectedApp || 'JB';
                if (app === 'BD') {
                    return `<span class="pc-fcm-badge">FCM</span>`;
                }
                const ic = (on, fa, label) =>
                    `<i class="fas ${fa} pc-eff${Number(on) === 1 ? ' is-on' : ''}" title="${label}: ${Number(on) === 1 ? '사용' : '미사용'}"></i>`;
                return ic(row.is_tts, 'fa-comment-dots', 'TTS')
                     + ic(row.is_popup, 'fa-window-maximize', '팝업')
                     + ic(row.is_sound, 'fa-volume-up', '효과음');
            }
        },
        {data: 'title', title: '푸시제목',
            render: function (data, type, row) {
                // 알림만(send_mode=2)이면 FCM 미발송 → 푸시제목 취소선 처리
                const s = `<span class="pc-sm90">${esc(row.title || '')}</span>`;
                return Number(row.send_mode) === 2 ? `<s class="pc-strike">${s}</s>` : s;
            }
        },
        {data: 'message', title: '푸시본문',
            render: function (data, type, row) {
                const inner = `<a href='#' data-pc='edit_pop' data-n='${row.num}' class='pc-msg-link'>${esc(row.message || '')}</a>`;
                return Number(row.send_mode) === 2 ? `<s class="pc-strike">${inner}</s>` : inner;
            }
        },
        {data: null, title: '테스트',
            render: function (data, type, row) {
                let html = '';
                html += `<button type='button' data-pc='push_send_test' data-n='${row.num}' data-mode='${Number(row.send_mode)}' class='pc-btn-test'>&nbsp;전송&nbsp;</button>`;
                if (['register', 'app_direct'].includes(row.rel_action)) {
                    html += `<button type="button" data-pc="empty_push_send_test" data-n="${row.num}" data-mode="${Number(row.send_mode)}" class="pc-btn-empty">&nbsp;빈푸시&nbsp;</button>`;
                }
                return html;
            }
        },
        // {data: 'mem_phone', title: '전화번호'},
        // {data: 'enter_date', title: '입사일',
        //     render: function (data, type, row, meta) {
        //         if(!data) return '';
        //         return dayjs(data).format('YY-MM-DD');
        //     }
        // },
    ];
    $table=new DataTable('#table', {
        columns,
        // 좌측 커스텀 컨트롤(신규추가+푸시테스트유저) + 우측 검색칸을 한 줄에 배치
        dom: '<"d-flex justify-content-between align-items-center mb-2"<"push-toolbar-left">f>rtip',
        ajax: {
            url: '/adm/ajax/push/config/list',
            type: 'post',
            data: function(d){
                d.app = selectedApp;
            }
        },
        processing: true,
        serverSide: false,
        ordering: false,
        displayLength: 20, // 페이지당 10개의 행 표시
        lengthChange: false, // "Entries per page" 옵션 숨김
        searching: true,
        initComplete: function(){
            // 검색칸과 같은 줄로 컨트롤 이동
            $('.push-toolbar-left').append($('#pushControls'));   // 옮기면 sass 가 보인다(form-inline flex 유지)
            $('#table').toggleClass('fcm-wide', selectedApp === 'JB'); // JB 만 FCM 컬럼 넓게
        },
        // fixedHeader: true
    });
}

function initHandler(){
    // 앱 탭 전환 → 해당 앱의 푸시설정만 로드
    // 버튼·링크 — data-pc="함수명" (번호는 data-n, 테스트는 data-mode). 목록·모달이 다시 그려지므로 위임
    const CLICK = {
        showProtocolHelp, add_pop, save_push_test_mbno, saveit, tts_translate, tts_win,
        edit_pop:             (el) => edit_pop(Number(el.dataset.n)),
        push_send_test:       (el) => push_send_test(Number(el.dataset.n), Number(el.dataset.mode)),
        empty_push_send_test: (el) => empty_push_send_test(Number(el.dataset.n), Number(el.dataset.mode)),
    };
    $(document).on('click', '[data-pc]', function(e){
        const fn = CLICK[this.dataset.pc];
        if (!fn) return;
        if (this.tagName === 'A') e.preventDefault();
        fn(this);
    });
    // 모달의 FCM·알림 체크 → 종속행 접기
    $(document).on('change', '#inputform #fcm_chk, #inputform #alim_chk', applyFormFold);

    $('#appTabs').on('click', 'a', function(e){
        e.preventDefault();
        if($(this).hasClass('active')) return;
        $('#appTabs a').removeClass('active');
        $(this).addClass('active');
        selectedApp = $(this).data('app');
        $('#table').toggleClass('fcm-wide', selectedApp === 'JB'); // JB 만 FCM 컬럼 넓게
        $table.ajax.reload(); // FCM 컬럼이 selectedApp 으로 BD=배지/JB=앱효과 재렌더
    });
}

// ── 푸시설정 모달 (JS 빌드) ──────────────────────────────
let currentPushNum = 0; // tts_translate 용

function esc(s){ return $('<div>').text(s == null ? '' : String(s)).html(); }
function escAttr(s){ return esc(s).replace(/"/g, '&quot;'); }
function appLabel(code){ return code === 'BD' ? '악덕알리미' : '장비불러'; }
// rel_table 을 색상 배지로 — 테이블별 고정 색, 미정의는 secondary
const TABLE_BADGE = {
    order:      'primary',
    match:      'info',
    process:    'warning',
    member:     'success',
    cash:       'danger',
    point:      'danger',
    notice:     'dark',
    call:       'info',
    dv_report:  'success',
    dv_defense: 'warning',
};
function tableBadge(t){
    if (!t) return '';
    const cls = TABLE_BADGE[t] || 'secondary';
    return `<span class="badge badge-${cls}">${esc(t)}</span>`;
}
// 대상(target) 배지 — 주요 대상은 고정 색, 그 외는 문자열 해시로 팔레트에서 안정적 색 배정.
// bootstrap 배지 색이 8종뿐이라 다양성이 부족 → 팔레트 색을 --pc-bg 로 넘긴다(sass .pc-target).
const TARGET_BADGE = {
    '모두':     '#343a40', '관리자':   '#c62828', '제보자':   '#2e7d32',
    '회원':     '#1565c0', '발주자':   '#0277bd', '수발주자': '#00838f',
    '소유자':   '#6a1b9a', '수주자':   '#ad1457', '수주소유자': '#4527a0',
    '수주소속자': '#c2185b', '매칭회원': '#e65100', '업종회원': '#9e9d24',
    '작업기사': '#558b2f', '이전기사': '#827717', '계약자':   '#00695c',
    '상대방':   '#5d4037', '홀드유저': '#283593',
};
const TARGET_PALETTE = [
    '#1565c0', '#00838f', '#6a1b9a', '#ad1457', '#e65100',
    '#558b2f', '#4527a0', '#00695c', '#5d4037', '#283593',
    '#9e9d24', '#0277bd', '#c2185b', '#827717', '#37474f',
];
function targetBadge(t){
    if (!t) return '';
    let bg = TARGET_BADGE[t];
    if (!bg){
        let h = 0;
        for (let i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) >>> 0;
        bg = TARGET_PALETTE[h % TARGET_PALETTE.length];
    }
    return `<span class="badge pc-target" style="--pc-bg:${bg}">${esc(t)}</span>`;
}

// 모달 앱효과 체크박스 — 아이콘은 검은색 고정(상태는 체크박스로 표시).
function effectLabel(name, val, fa, text){
    const on = !!(val && val != '0');
    return `<label><input type="checkbox" name="${name}" value="1" ${on ? 'checked' : ''}>`
         + `<i class="fas ${fa} pc-eff-ic"></i>${text}</label>`;
}

function buildPushForm(row, isNew){
    row = row || {};
    const app = row.app_code || selectedApp || 'JB';
    const isBD = app === 'BD'; // 악덕알리미 앱은 TTS·효과음 기능 없음 → 관련 입력 숨김
    const isOrderLike = ['order','match'].includes(row.rel_table || '');
    const isDevilDoc  = ['dv_report','dv_defense'].includes(row.rel_table || ''); // 알림페이지 제목/내용 자동생성 → 편집 잠금
    const ck = v => (v && v != '0') ? 'checked' : '';

    let identityRows;
    if(isNew){
        identityRows = `
            <input type="hidden" name="app_code" value="${escAttr(app)}">
            <tr><th>앱</th><td>${esc(appLabel(app))}</td></tr>
            <tr><th>table <span class="pc-req">*</span></th><td><input type="text" name="rel_table" placeholder="예: dv_report, call, order" class="pc-w100"></td></tr>
            <tr><th>action</th><td><input type="text" name="rel_action" placeholder="예: approved, after_call (없으면 비움)" class="pc-w100"></td></tr>
            <tr><th>대상 <span class="pc-req">*</span></th><td><input type="text" name="target" placeholder="예: 신고자, 관리자, 통화당사자" class="pc-w100"></td></tr>
            <tr><th>설명</th><td><input type="text" name="event" placeholder="관리자용 설명" class="pc-w100"></td></tr>
            ${isBD ? '' : '<tr><th>효과음 파일(sound_fn)</th><td><input type="text" name="sound_fn" maxlength="1" placeholder="예: D, M, T (1글자)" class="pc-w80"></td></tr>'}
            <tr><th>정렬(odr)</th><td><input type="text" name="odr" value="9999" class="pc-w80"></td></tr>`;
    } else {
        // table·action·대상은 편집 후에도 읽기전용이다 — 이 셋이 UNIQUE 키이자
        // 앱이 분기에 쓰는 v2_hash(`table>action>대상`) 라, 여기서 고치면 앱의
        // 디스패치가 조용히 다른 곳을 가리킨다.
        // 설명(event)은 관리자용 메모라 그런 결합이 없어 편집을 연다.
        identityRows = `
            <tr><th>앱</th><td>${esc(appLabel(app))}</td></tr>
            <tr><th>table</th><td>${esc(row.rel_table)}</td></tr>
            <tr><th>action</th><td>${esc(row.rel_action)}</td></tr>
            <tr><th>대상</th><td>${esc(row.target)}</td></tr>
            <tr><th>설명</th><td><input type="text" name="event" value="${escAttr(row.event)}" placeholder="관리자용 설명" class="pc-w100"></td></tr>`;
    }

    const mgColor = row.mg_color || 'black';
    // 알림페이지 제목/내용이 자동 생성되는 케이스(order/match, dv_report/dv_defense)는 편집 잠금.
    const mgPlaceholder = isDevilDoc ? '신고/소명 알림은 제목·내용이 자동 생성됩니다.' : '오더관련 알림은 내용을 편집할수없습니다.';
    const mgTitleCell = isDevilDoc   // 제목 잠금은 dv_report/dv_defense 만 (order 의 제목은 기존대로 편집 가능)
        ? `<input type="text" disabled placeholder="${mgPlaceholder}" class="pc-w80p">`
        : `<input type="text" name="mg_title" value="${escAttr(row.mg_title)}" class="pc-w80p">`;
    const mgBodyCell = (isOrderLike || isDevilDoc)
        ? `<textarea class="pc-h60" disabled placeholder="${mgPlaceholder}"></textarea>`
        : `<textarea name="mg_body" class="pc-h60">${esc(row.mg_body)}</textarea>`;

    return `
    <div class="push-form">
      <form id="inputform" name="inputform">
        <input type="hidden" name="num" value="${escAttr(row.num || 0)}">
        <table>
          ${identityRows}
          <!-- 전달방식: FCM/알림 체크박스 2개 → applyFormFold 가 send_mode(hidden) 파생 + 종속행 접기 -->
          <tr><th>FCM 발송</th><td class="chk-group">
            <input type="hidden" name="send_mode" value="${(row.send_mode === undefined ? 1 : Number(row.send_mode)) || 1}">
            <label title="끄면 FCM 미발송 — 푸시 제목/본문/예제 접힘"><input type="checkbox" id="fcm_chk" ${Number(row.send_mode) !== 2 ? 'checked' : ''}><b>FCM 푸시 발송</b></label>
            <div class="fcm-hint">끄면 푸시(FCM) 미발송 — 아래 푸시 제목·본문·예제가 접힙니다.</div>
            ${isBD ? '' : `<div class="fcm-sub fcm-dep">
              ${effectLabel('is_tts',   row.is_tts,   'fa-comment-dots',    'TTS')}
              ${effectLabel('is_popup', row.is_popup, 'fa-window-maximize', '푸시알림 표시')}
              ${effectLabel('is_sound', row.is_sound, 'fa-volume-up',       '효과음')}
            </div>`}
          </td></tr>
          <tr class="fcm-dep"><th>푸시 타이틀</th><td><input type="text" name="title" value="${escAttr(row.title)}" class="pc-w100"></td></tr>
          <tr class="fcm-dep"><th>푸시 본문 내용</th><td><textarea name="message" class="pc-h60">${esc(row.message)}</textarea></td></tr>
          <tr class="fcm-dep"><th><a href="#" data-pc="tts_translate">본문 예제 <i class="fas fa-redo-alt pc-blue-ic"></i></a></th>
              <td><span id="tts_text"></span>
                  <i class="fas fa-copy clipboard pc-copy" data-clipboard-target="#tts_text"> 복사</i>
                  ${isBD ? '' : '<div class="pc-tts-row"><a href="#" data-pc="tts_win" class="pc-tts-link">TTS 테스트 사이트 [새창]</a></div>'}
              </td></tr>
          <tr><th>알림 기록</th><td class="chk-group">
            <label title="끄면 알림페이지(DB) 미기록 — 알림 제목/내용 접힘"><input type="checkbox" id="alim_chk" ${Number(row.send_mode) !== 3 ? 'checked' : ''}><b>알림페이지(DB) 기록</b></label>
            <div class="fcm-hint">끄면 알림페이지 미기록 — 아래 알림 제목·내용이 접힙니다.</div>
          </td></tr>
          <tr class="alim-dep"><th>알림페이지 제목</th><td>
              ${mgTitleCell}
              <span class="pc-swatch" style="--pc-swatch:${escAttr(mgColor)}">&nbsp;</span>
          </td></tr>
          <tr class="alim-dep"><th>알림페이지 내용</th><td>${mgBodyCell}</td></tr>
        </table>
        <div class="pc-save">
          <button type="button" class="btn btn-primary px-5" data-pc="saveit"><i class="fas fa-check mr-1"></i>저장</button>
        </div>
      </form>
    </div>`;
}

function openPushModal(row, isNew){
    currentPushNum = isNew ? 0 : (row.num || 0);
    const title = isNew ? '푸시 설정 추가' : '푸시 설정';
    $j.Ui.JBModal.html('jb-modal-push', buildPushForm(row, isNew), title);
    applyFormFold(); // FCM/알림 체크 상태로 종속행 접기 + send_mode(hidden) 초기 반영
    if(!isNew) tts_translate();
    if(typeof ClipboardJS !== 'undefined') new ClipboardJS('.clipboard');
}

// FCM/알림 체크 상태에 따라 종속행을 접고(.fcm-dep / .alim-dep 표시·숨김),
// 두 체크 조합으로 send_mode(hidden)를 파생한다. 숨겨도 serialize 에는 포함되어 값은 보존된다.
//   FCM✓알림✓=1(푸시+알림)  FCM✗알림✓=2(알림만)  FCM✓알림✗=3(푸시만)  둘다✗=0(저장 차단)
function applyFormFold(){
    const fcm  = $('#inputform #fcm_chk').prop('checked');
    const alim = $('#inputform #alim_chk').prop('checked');
    $('#inputform .fcm-dep').toggle(fcm);   // 푸시 제목/본문/예제(+효과) 접기
    $('#inputform .alim-dep').toggle(alim); // 알림 제목/내용 접기
    const mode = (fcm && alim) ? 1 : (fcm ? 3 : (alim ? 2 : 0));
    $('#inputform input[name=send_mode]').val(mode);
}

function edit_pop(n){
    // 목록(DataTable)에 이미 로드된 행 데이터 재사용 — 별도 서버 조회 없음
    const row = $table.rows().data().toArray().find(r => String(r.num) === String(n)) || {num: n};
    openPushModal(row, false);
}
function add_pop(){
    openPushModal({app_code: selectedApp}, true); // 현재 탭(앱)으로 신규 등록
}

function saveit(){
    // FCM·알림 둘 다 끄면 send_mode=0 → 의미 없는 설정이라 저장 차단
    if (Number($('#inputform input[name=send_mode]').val()) === 0) {
        $j.F.Admin.Util.tsalert('error', 'FCM 발송 또는 알림 기록 중 최소 하나는 켜야 합니다.');
        return;
    }
    $.ajax({
        type: 'post', url: '/adm/ajax/push/config/save', data: $('#inputform').serialize(),
        success: function(data){
            if(!data.result){ $j.F.Admin.Util.tsalert('error', data.message || '오류발생'); return; }
            $j.F.Admin.Util.tsalert('success', data.message || '저장되었습니다.');
            $j.Ui.JBModal.close('jb-modal-push');
            $table.ajax.reload(null, false);
        }
    });
}
function tts_translate(){
    $.ajax({
        type: 'post', url: '/adm/ajax/push/translate', data: {num: currentPushNum},
        success: function(data){ if(data.result) $('#tts_text').html(data.info); }
    });
}
function tts_win(){
    window.open('https://text-to-speech.imtranslator.net/speech.asp?dir=ko', 'tts_win', 'toolbar=no,status=no,WIDTH=1024,HEIGHT=800,scrollbars=yes');
}
function push_send_test(num, mode){
    // 알림만(send_mode=2)은 FCM 미발송이라 테스트 푸시도 보내지 않는다(서버에서도 재차단)
    if (Number(mode) === 2) {
        $j.F.Admin.Util.tsalert('warning', 'FCM 미발송(알림만) 설정이라 테스트 푸시를 보내지 않습니다. (알림페이지 DB 적재 전용)');
        return;
    }
    var sendData = {
        'mb_no': $('#push_test_mbno').val().trim(),
        'num': num
    };
    var tar_url = '/adm/ajax/push/send/test';
    $.ajax({
        type: 'post', url: tar_url, data: sendData, success: function (data) {
            if(!data.result) {
                $j.F.Admin.Util.tsalert('error', data.message);
                return;
            }
            $j.F.Admin.Util.tsalert('success', $('#push_test_mbno').val().trim() + ' 회원님에게 전공성공했습니다');
        }
    });
}

/**
 * 빈푸시 전송 테스트
 * @param num
 */
function empty_push_send_test(num, mode){
    if (Number(mode) === 2) {
        $j.F.Admin.Util.tsalert('warning', 'FCM 미발송(알림만) 설정이라 테스트 푸시를 보내지 않습니다. (알림페이지 DB 적재 전용)');
        return;
    }
    var sendData = {
        'mb_no': $('#push_test_mbno').val().trim(),
        'ver': $('#firebase_ver').val(),
        'num':num
    };
    var tar_url = '/adm/ajax/push/send/empty';
    $.ajax({type : 'post',url : tar_url,data: sendData,success : function (data){
            if(!data.result) {
                $j.F.Admin.Util.tsalert('error', data.message);
                return;
            }
            $j.F.Admin.Util.tsalert('success',$('#push_test_mbno').val().trim()+' 회원님에게 전공성공했습니다');
        }});
}
function save_push_test_mbno(){
    let mb_no = $('#push_test_mbno').val();
    var sendData = {'mb_no':mb_no};
    var tar_url = '/adm/ajax/push/save/tester';
    $.ajax({type : 'post',
        url : tar_url,
        data: sendData,
        success : function (data){
            if( data.result ){
                $j.F.Admin.Util.tsalert('success','변경하였습니다.');
            }else{
                $j.F.Admin.Util.tsalert('error','에러가 발생하였습니다.');
            }
        },
    });
}

// ── 푸시 프로토콜 도움말 ─────────────────────────────────
// 현재 선택된 앱 탭(JB/BD) 기준으로 firebase 전송 페이로드 예제와 흐름을 보여준다.
// 예제 JSON 은 노드(fcm.js)가 토큰별로 FCM HTTP v1 에 실제 POST 하는 message 본문 구조.

// FCM HTTP v1 message 예제 — 앱별 형식 차이 반영 (PushSender::buildFields 와 동일 구조).
function fcmExample(app){
    if(app === 'BD'){
        // 악덕알리미: data-only. 식별값과 제목·본문만 싣고 v2_* 플래그 없음. ver 는 노드(fcm.js)가 붙인다.
        return {
            message: {
                android: { priority: 'high', ttl: '86400s' },
                data: {
                    v2_hash: 'dv_report>approved>제보자',
                    key: '4821',
                    notiTitle: '신고가 접수되었습니다',
                    message: '○○건설(체불 250,000원) 신고가 접수되었습니다.',
                    ver: 'v1'
                },
                token: 'cZ1f9k...(단말 FCM 토큰)'
            }
        };
    }
    // 장비불러: data-only. 트레이 알림/팝업/TTS/효과음을 앱이 data 플래그로 직접 처리.
    return {
        message: {
            android: { priority: 'high', ttl: '86400s' },
            data: {
                v2_popup_use: '1',
                v2_tts_use:   '1',
                v2_tts_type:  '2',
                v2_sound_use: '1',
                v2_hash:      'match>매칭회원',
                sound_fn:     'M',
                notiTitle:    '매칭 알림',
                message:      '오늘 14시 스카이 1톤 강남구 역삼동 현장 매칭되었습니다.',
                key:          '309115',
                ver:          'v1'
            },
            token: 'fE2aQz...(단말 FCM 토큰)'
        }
    };
}

// JSON 을 키/문자열 색상 강조한 HTML 로 — pre.help-json 안에 표시.
// esc()(jQuery text→html)는 < > & 만 이스케이프하고 "는 그대로 두므로 리터럴 " 기준으로 매칭.
function highlightJson(obj){
    const json = esc(JSON.stringify(obj, null, 2));
    return json
        .replace(/"([^"]+)"(\s*:)/g, '<span class="jk">"$1"</span>$2')   // key
        .replace(/(:\s*)"([^"]*)"/g, '$1<span class="js">"$2"</span>');  // string value
}

const HELP_FIELDS = {
    JB: [
        ['android.priority',  "'high'",              '안드로이드 우선순위 — 즉시 전달'],
        ['android.ttl',       "'86400s'",            '미수신 시 FCM 보관 기간(24시간)'],
        ['data.v2_popup_use', '팝업(is_popup)',       "'1'이면 앱이 인앱 팝업 표시"],
        ['data.v2_tts_use',   'TTS(is_tts)',          "'1'이면 TTS 음성 재생"],
        ['data.v2_tts_type',  '자동(hash)',           "접수='1' / 매칭='2' / 그외=''(message 본문을 그대로 읽음)"],
        ['data.v2_sound_use', '효과음(is_sound)',     "'1'이면 효과음 재생"],
        ['data.sound_fn',     '효과음 파일(sound_fn)', '재생할 음원 키 (예: D, M, T)'],
        ['data.v2_hash',      'table&gt;action&gt;대상', '알림 분류 키 — 앱 내 화면 라우팅'],
        ['data.notiTitle',    '푸시 타이틀(title)',    '트레이 알림 제목 — 앱이 직접 그림'],
        ['data.message',      '푸시 본문(message)',    '{word} 토큰이 실데이터로 치환된 최종 문구'],
        ['data.key',          '레코드 num',           '관련 레코드 PK — 딥링크용'],
        ['data.ver',          "고정 'v1'",            '앱 호환 표식 — 노드가 항상 보장'],
        ['token',             '단말 토큰',            'g5_member_devices(app_code=JB) 에서 조회'],
    ],
    BD: [
        ['android.priority',   "'high'",                '안드로이드 우선순위 — 즉시 전달'],
        ['android.ttl',        "'86400s'",              '미수신 시 FCM 보관 기간(24시간)'],
        ['data.v2_hash',       'table&gt;action&gt;대상', '알림 분류 키 — 앱 내 화면 라우팅'],
        ['data.key',           '레코드 num',            '관련 레코드 PK — 딥링크용'],
        ['data.notiTitle',     '푸시 타이틀(title)',     '트레이 알림 제목 — 앱이 직접 그림. 비었으면 키가 빠진다'],
        ['data.message',       '푸시 본문(message)',     '트레이 알림 본문 — 앱이 직접 그림. 비었으면 키가 빠진다'],
        ['data.ver',           "고정 'v1'",             '노드가 항상 붙인다 — 이 앱은 읽지 않는다'],
        ['token',              '단말 토큰',             'g5_member_devices(app_code=BD) 에서 조회'],
    ],
};

function buildProtocolHelp(app){
    const isBD     = app === 'BD';
    const appName  = isBD ? '악덕알리미' : '장비불러';

    const fieldRows = HELP_FIELDS[app].map(f =>
        `<tr><td>${f[0]}</td><td>${f[1]}</td><td>${esc(f[2])}</td></tr>`
    ).join('');

    const protoNote = isBD
        ? `<b>악덕알리미(BD)</b> 도 <code>data</code> 전용(notification 블록 없음)이고 트레이 알림을 앱이 직접 그립니다.
           <code>data</code> 는 <code>v2_hash</code>·<code>key</code>·<code>notiTitle</code>·<code>message</code> 만 싣고(<code>ver</code> 는 노드가 붙입니다), TTS·효과음 플래그는 없습니다.
           소리/진동은 앱의 alertMode 설정이 결정합니다.`
        : `<b>장비불러(JB)</b> 는 <code>data</code> 전용(notification 블록 없음)입니다.
           트레이 알림·팝업·TTS·효과음을 모두 앱이 <code>v2_*</code> 플래그를 보고 직접 처리합니다.`;

    return `
    <div class="push-help">
      <div class="pc-help-head">
        <span class="help-app-badge ${isBD ? 'is-bd' : 'is-jb'}">${appName}</span>
        <span class="help-muted">앱코드 <code>${app}</code> · FCM HTTP v1 (data 전용)</span>
      </div>

      <h4>1. FCM 에 실제 전송되는 message 예제</h4>
      <p class="help-muted pc-help-lead">
        노드가 토큰마다 <code>{ "message": { … , "token": "…" } }</code> 형태로 POST 합니다. 아래는 <code>message</code> 본문.
      </p>
      <pre class="help-json">${highlightJson(fcmExample(app))}</pre>
      <div class="help-note">${protoNote}</div>

      <h4>2. 필드 설명</h4>
      <table class="help-fields">
        <thead><tr><th>필드</th><th>출처(설정)</th><th>설명</th></tr></thead>
        <tbody>${fieldRows}</tbody>
      </table>
    </div>`;
}

function showProtocolHelp(){
    const app = selectedApp || 'JB';
    const title = '푸시 프로토콜 도움말 — ' + (app === 'BD' ? '악덕알리미' : '장비불러');
    $j.Ui.JBModal.html('jb-modal-help', buildProtocolHelp(app), title);
}
